export default __webpack_public_path__ + "static/media/dell.e0145b59.svg";